import React, {useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { SettingsContext } from '../contexts/index.jsx';
import { Carousel, ListingList, SubmitButton } from "../components"
import { RecentNews, RecentEvents } from "./LandingUser/index.jsx"
import { Collapsible } from "../components"
import { Product } from "./FindProduct/index.jsx"
import { ProductSearchHelper } from "../helpers"
import { api } from '../core/services';

const loadImages = async callback => {
    const images = await api.get('/api/content-images/homepage-carousel');

    callback(images);
};

const LandingUser = () => {
    const history = useHistory();
    const settings = useContext(SettingsContext);
    const [images, setImages] = useState([]);

    useEffect(() => {
        loadImages(setImages);
    }, [setImages]);

    return (
        <main id='landing-user' className="flex-grow-1">
          {!settings.isShopify && (
            <Carousel images={images}/>
          )}

          <div className="embedded-source">
            <main id='find-product' className="flex-grow-1 step-product">
              <div className="container">
                <div className="collapsibles first-collapsible">
                    <Collapsible
                        trigger="Watch Order"
                        handleTriggerClick={() => {}}
                        open
                    >
                        <div className="mt-2 mt-lg-4 find-product-product">
                            <Product
                              limit={32}
                              firstPageOnly
                              showSearchMore
                              requestType="order"
                            />
                        </div>
                    </Collapsible>
                </div>
              </div>
            </main>
          </div>

            <section className="products">
                <div className="container">
                    <h2>Latest arrivals</h2>

                    <ListingList
                        limit={16}
                        maxItemsCount={32}
                        {...ProductSearchHelper.prepareForServer({})}
                    >

                        <div className="discover-all-watches">
                            <SubmitButton
                                onClick={() => history.push(`/products/watches?${settings.iframeQueryParams}`)}
                                label="Discover all watches"
                            />
                        </div>
                    </ListingList>
                </div>
            </section>

          {!settings.isShopify && (
            <>
              <section className="news">
                  <div className="container">
                      <Link to="/news"><h2>News</h2></Link>

                      <RecentNews />
                  </div>
              </section>

              <section className="events">
                  <div className="container">
                      <h2>Events</h2>

                      <RecentEvents />
                  </div>
              </section>
            </>
          )}
        </main>
    )
}

export default LandingUser
